export default __webpack_public_path__ + "static/100--stacked-column-03d1cddcbf47ea02debb266ff697b624.png";